import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useRatingsDateFilterStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        ...shorthands.gap(tokens.spacingHorizontalM),
        ...shorthands.padding(
            tokens.spacingVerticalM,
            tokens.spacingHorizontalM
        ),
        backgroundColor: tokens.colorNeutralBackground2,
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        marginBottom: tokens.spacingVerticalL,
    },
    dateField: {
        minWidth: '180px',
    },
    buttonGroup: {
        display: 'flex',
        ...shorthands.gap(tokens.spacingHorizontalS),
    },
});
